var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"btt"}},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"btt",attrs:{"type":"button","aria-label":"回到顶部","title":"回到顶部"},on:{"click":_vm.toTop}},[_c('span',{staticClass:"btt__arrow"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }